
<div class="alert alert-{{ type }} alert-dismissible fade show" role="alert">

  <ng-content></ng-content>

  <button 
    *ngIf="dismissible"
    type="button" 
    class="btn-close"
    aria-label="Close"
    (click)="close()">
  </button>
</div>
